// "Recently used" special-character history for SpecialCharDialog
// (localStorage; per-browser, not per-account — same tradeoff as cart.js).
//
// Stored shape: [{ code, char, name }, ...] newest first.

const HISTORY_KEY = 'ss-v2-special-char-history';
const MAX_HISTORY = 16;

export function readSpecialCharHistory() {
  try {
    const raw = window.localStorage.getItem(HISTORY_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

// Moves/inserts `entry` to the front (dedup by code) and persists the
// trimmed list. Returns the new list so callers can sync state in one step.
export function recordSpecialCharUsed(entry) {
  const next = [entry, ...readSpecialCharHistory().filter((e) => e.code !== entry.code)].slice(0, MAX_HISTORY);
  try {
    window.localStorage.setItem(HISTORY_KEY, JSON.stringify(next));
  } catch {
    /* storage unavailable — non-fatal */
  }
  return next;
}
